export interface MaintenanceConfig {
  enabled: boolean;
}

const MAINTENANCE_CONFIG_PATH = "/maintenance.json";

export async function fetchMaintenanceConfig(): Promise<MaintenanceConfig> {
  try {
    const response = await fetch(`${MAINTENANCE_CONFIG_PATH}?t=${Date.now()}`, {
      cache: "no-store",
    });

    if (!response.ok) {
      return { enabled: false };
    }

    const data = (await response.json()) as Partial<MaintenanceConfig>;
    return { enabled: data.enabled === true };
  } catch {
    return { enabled: false };
  }
}
